import { useMemo } from "react";
import { BLOCK_CAT_TO_EVENT } from "./constants";

// Build the unified event list (Date objects) + the set of days that have availability.
export function useCalendarEvents({ value, busy, blocks, bookings, t }) {
  const events = useMemo(() => {
    const list = [];
    const bookedKeys = new Set();
    (bookings || []).forEach((b) => {
      const st = new Date(b.start), en = new Date(b.end);
      if (["confirmed", "completed", "pending"].includes(b.status)) bookedKeys.add(st.getTime());
      if (b.status === "confirmed" || b.status === "completed")
        list.push({ id: "bk_" + b.booking_id, start: st, end: en, category: "booked_coaching", title: b.topic || t("cal.catBookedCoaching"), subtitle: b.employee_name, kind: "booking", data: b });
      else if (b.status === "pending")
        list.push({ id: "pd_" + b.booking_id, start: st, end: en, category: "pending_tentative", title: b.topic || t("cal.catPending"), subtitle: b.employee_name, kind: "booking", data: b });
    });
    (busy || []).forEach((x, i) => list.push({ id: `busy_${x.start}_${i}`, start: new Date(x.start), end: new Date(x.end), category: "external_busy", title: t("cal.busyLabel"), kind: "busy" }));
    (blocks || []).forEach((bl) => list.push({ id: "tb_" + bl.id, start: new Date(bl.start), end: new Date(bl.end), category: BLOCK_CAT_TO_EVENT[bl.category] || "personal", title: bl.title || t(`cal.cat.${bl.category}`), kind: "block", data: bl }));
    (value || []).forEach((s) => {
      const st = new Date(s.start);
      if (s.booked || bookedKeys.has(st.getTime())) return;
      list.push({ id: "av_" + s.id, start: st, end: new Date(s.end), category: "available", title: t("cal.available"), kind: "avail", data: s });
    });
    return list;
  }, [value, busy, blocks, bookings, t]);

  const availDays = useMemo(() => new Set((value || []).map((s) => new Date(s.start).toDateString())), [value]);

  return { events, availDays };
}
